"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DIRECTION = exports.DEVICE_TYPE = exports.DEFAULT_STYLE = exports.COMP_TYPES = void 0;
var DEFAULT_STYLE = {
  DEFAULT_BACKGROUND_COLOR: 'primary',
  DEFAULT_FONT_SIZE: 'XSmall',
  DEFAULT_TEXT_COLOR: 'greyDark',
  DEFAULT_LINE_HEIGHT: 'small',
  DEFAULT_IMAGE_HEIGHT: '68px',
  DEFAULT_IMAGE_WIDTH: '68px'
};
exports.DEFAULT_STYLE = DEFAULT_STYLE;
var DEVICE_TYPE = {
  desktop: 'desktop',
  mobile: 'mobile',
  tablet: 'tablet'
};
exports.DEVICE_TYPE = DEVICE_TYPE;
var COMP_TYPES = {
  IMAGE: 'image',
  FOOTER_NOTES: 'footer-notes'
};
exports.COMP_TYPES = COMP_TYPES;
var DIRECTION = {
  LEFT: 'left',
  RIGHT: 'right'
};
exports.DIRECTION = DIRECTION;